import React, { Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { X } from 'lucide-react';
import PersonalWaConnect from './PersonalWaConnect';

interface PersonalWaConnectModalProps {
  open: boolean;
  configId: string | null;
  initialStatus?: string;
  initialError?: string | null;
  onClose: () => void;
  onConnected?: () => void;
  onDisconnected?: () => void;
}

const PersonalWaConnectModal: React.FC<PersonalWaConnectModalProps> = ({
  open,
  configId,
  initialStatus = 'disconnected',
  initialError = null,
  onClose,
  onConnected,
  onDisconnected,
}) => {
  return (
    <Transition appear show={open && !!configId} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-200"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-150"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div
            style={{
              position: 'fixed',
              inset: 0,
              background: 'rgba(15,23,42,0.4)',
              backdropFilter: 'blur(4px)',
            }}
          />
        </Transition.Child>
        <div style={{ position: 'fixed', inset: 0, overflowY: 'auto' }}>
          <div
            style={{
              display: 'flex',
              minHeight: '100%',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '1rem',
            }}
          >
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-200"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-150"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel
                style={{
                  width: '100%',
                  maxWidth: 480,
                  background: 'white',
                  borderRadius: 18,
                  padding: '1.5rem',
                  boxShadow: '0 24px 60px rgba(0,0,0,0.15)',
                  border: '1px solid #e2e8f0',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginBottom: '1rem',
                  }}
                >
                  <Dialog.Title
                    style={{
                      margin: 0,
                      fontSize: '1.0625rem',
                      fontWeight: 700,
                      color: '#0f172a',
                      fontFamily: 'Inter, sans-serif',
                    }}
                  >
                    Connect Personal WhatsApp
                  </Dialog.Title>
                  <button
                    type="button"
                    onClick={onClose}
                    style={{
                      padding: 4,
                      borderRadius: 8,
                      border: 'none',
                      background: 'none',
                      cursor: 'pointer',
                      color: '#94a3b8',
                      display: 'flex',
                    }}
                  >
                    <X style={{ width: 18, height: 18 }} />
                  </button>
                </div>
                {configId && (
                  <PersonalWaConnect
                    configId={configId}
                    initialStatus={initialStatus}
                    initialError={initialError}
                    onConnected={onConnected}
                    onDisconnected={onDisconnected}
                  />
                )}
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default PersonalWaConnectModal;
